import React from 'react';
import Leadership from "../components/Leadership";

const App = () => {
	return (
		<div className="App">
			<Leadership />
		</div>
	);
};

export default App;